import { type ComponentType } from "react";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";

export function WithLoading<T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  WrappedComponent: ComponentType<T & any>,
) {
  const WithLoading = (props: T) => {
    const isFetching = useIsFetching();
    const isMutating = useIsMutating();

    return (
      <>
        {isFetching || isMutating ? <LoadingSpinner /> : null}
        <WrappedComponent {...props} />
      </>
    );
  };

  return WithLoading;
}
